/* eslint-disable func-names */
import $ from "jquery";
import Swiper from 'swiper';
import { Autoplay, Pagination, Navigation, EffectFade, Scrollbar } from 'swiper/modules';
import 'swiper/css/bundle';
import 'swiper/css/effect-fade';

const contract = () => {
    const swiper = new Swiper(".js-contract-swiper", {
        modules: [Navigation, Scrollbar],
        speed: 1000,
        slidesPerView: 1.5,
        spaceBetween: 20,
        centeredSlides: true,
        freeMode: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        scrollbar: {
            el: '.swiper-scrollbar',
        },
        breakpoints: {
            768: {
                freeMode: false,
                centeredSlides: false,
                slidesPerView: 4,
            }
        }
    });
}
const main = () => {
    if (document.querySelector('#page-assessment') === null) return;
    contract();
}
export default main;
